import { render, staticRenderFns } from "./ClCardActionArea.html?vue&type=template&id=b3be676a&"
import script from "./ClCardActionArea.ts?vue&type=script&lang=ts&"
export * from "./ClCardActionArea.ts?vue&type=script&lang=ts&"
import style0 from "./ClCardActionArea.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports